import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { RegistrationPasswordField } from "./RegistrationPasswordField";
import {
  REGISTRATION_PASSWORD_HINT,
  getRegistrationPasswordFieldSx,
} from "./registrationPasswordFieldStyles";

const DEFAULT_PASSWORD_TOOLTIP =
  "Enter a strong password with at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character";
const DEFAULT_CONFIRM_TOOLTIP = "Confirm your password by entering it again";

export function RegistrationPasswordFieldsSection({
  formData,
  handleInputChange,
  validatePassword,
  validateConfirmPassword,
  passwordError,
  confirmPasswordError,
  primaryColor,
  onKeyDown,
  passwordPlaceholder = "Enter your password here",
  confirmPlaceholder = "Confirm your password here",
  passwordTooltip = DEFAULT_PASSWORD_TOOLTIP,
  confirmTooltip = DEFAULT_CONFIRM_TOOLTIP,
}) {
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
          Password
        </Typography>
        <Tooltip title={passwordTooltip} placement="top" arrow>
          <IconButton size="small" sx={{ color: "text.secondary", p: 0 }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <RegistrationPasswordField
        fullWidth
        variant="outlined"
        name="password"
        required
        value={formData.password}
        onChange={handleInputChange}
        onKeyDown={onKeyDown}
        onBlur={validatePassword}
        placeholder={passwordPlaceholder}
        error={!!passwordError}
        helperText={passwordError || (formData.password ? REGISTRATION_PASSWORD_HINT : "")}
        sx={getRegistrationPasswordFieldSx(passwordError, primaryColor, true)}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
          Confirm Password
        </Typography>
        <Tooltip title={confirmTooltip} placement="top" arrow>
          <IconButton size="small" sx={{ color: "text.secondary", p: 0 }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <RegistrationPasswordField
        fullWidth
        variant="outlined"
        name="confirmPassword"
        required
        value={formData.confirmPassword}
        onChange={handleInputChange}
        onKeyDown={onKeyDown}
        onBlur={validateConfirmPassword}
        placeholder={confirmPlaceholder}
        error={!!confirmPasswordError}
        helperText={confirmPasswordError}
        sx={getRegistrationPasswordFieldSx(confirmPasswordError, primaryColor)}
      />
    </>
  );
}
